import axios from 'axios'
import { CommonMorphologicCodeResponse } from '@/api/services/common/morphologic-code/common-morphologic-code.dto'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonMorphologicCodeService {
    async getMorphologicCodes(): Promise<CommonMorphologicCodeResponse[]> {
        const response =
            await axios.get<CommonMorphologicCodeResponse[]>(
                `/mostLikelyMorphologicCodes/`)
        return orderBy(
            response.data,
            element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }

    async searchMorphologicCodes(query: string, params?: CommonParams): Promise<CommonMorphologicCodeResponse[]> {
        const response =
            await axios.get<CommonMorphologicCodeResponse[]>(
                `/morphologicCodes/search`,
                { params: { query, ...params } })
        return orderBy(
            response.data,
            element => TextNormalization.removeDiacritics(element.description), ['asc'])
    }
}
export const commonMorphologicCodeService = new CommonMorphologicCodeService()
